import { useLayoutEffect } from "react";
import { useLocation } from "@tanstack/react-router";
import { hostKind } from "@/lib/hostKind";

/** One document boundary includes body portals and excludes operator utilities. */
export function usesApprovedDesign(pathname: string, host: string): boolean {
  return (
    host !== "admin" &&
    !/^\/(super-admin|welcome|canvas-demo)(\/|$)/.test(pathname)
  );
}

export function VisualSystem() {
  const { pathname } = useLocation();
  const enabled = usesApprovedDesign(pathname, hostKind());
  useLayoutEffect(() => {
    const root = document.documentElement;
    if (enabled) root.dataset.ui = "approved-v5";
    else delete root.dataset.ui;
    root.dataset.surface = pathname === "/" ? "marketing" : "app";
    return () => {
      delete root.dataset.ui;
      delete root.dataset.surface;
    };
  }, [enabled, pathname]);
  return null;
}
